import { Button, Card, CardContent } from "@elit-hair/elit-ui";
import type { TooltipRenderProps } from "react-joyride";

export const CustomJoyrideTooltip = ({
    step,
    tooltipProps,
    backProps,
    closeProps,
    primaryProps,
    skipProps,
    index,
    isLastStep,
}: TooltipRenderProps) => {
    return (
        <div {...tooltipProps} className="z-guidedTour">
            <Card className="shadow-lg border-primary">
                <CardContent className="p-4 flex flex-col gap-2">
                    <div className="mb-2 text-base font-semibold">{step.title}</div>
                    <div className="text-sm text-muted-foreground">{step.content}</div>
                    <div className="flex gap-2 justify-end mt-4">
                        {index > 0 && (
                            <Button size="sm" variant="outline" {...backProps}>
                                {backProps.title}
                            </Button>
                        )}
                        <Button size="sm" variant="ghost" {...skipProps}>
                            {skipProps.title}
                        </Button>
                        <Button size="sm" variant="default" {...(isLastStep ? closeProps : primaryProps)}>
                            {isLastStep ? closeProps.title : primaryProps.title}
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};
